<template>
    <b-modal
        modal-class="modal-full action-modal"
        :visible="visible"
    >
        <template #modal-header>
            <div class="container">
                <h3 class="mb-0">Client Action #{{ clientActionId }}</h3>
            </div>
            <button @click="hideModal" type="button" aria-label="Close" class="close">×</button>
        </template>
        <client-action-item
            v-if="clientActionId !== null"
            :client-action-id="clientActionId"
            :show-action-buttons="false"
            :clientAction="clientAction"
            @refresh="fetch(clientActionId)"
            @close="hideModal"
        >
        </client-action-item>
        <template #modal-footer>
            <client-action-buttons
                    @close="hideModal"
                    :clientAction="clientAction"
            >
            </client-action-buttons>
        </template>
    </b-modal>
</template>

<script>
import ModalMixin from '@/components/Modal/ModalMixin';
import ClientActionItem from '@/components/Action/ClientAction';
import ClientActionButtons from '@/components/Action/ClientActionButtons';
import ClientActionAssign from '@/services/Action/ClientActionAssign';
import ClientAction from '@/services/Action/ClientAction';

export default {
  name: 'Client-Action-Modal',
  components: {
    ClientActionItem,
    ClientActionButtons,
  },
  props: {
    clientActionId: {
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [ModalMixin],
  data() {
    return {
      modalId: 'clientActionModal',
      loading: false,
      visible: false,
      clientAction: [],
    };
  },
  watch: {
    clientActionId: {
      handler(newId) {
        this.loading = true;
        this.fetch(newId)
          .catch(() => {
            this.$notify({
              duration: 5000,
              title: 'Error',
              text: 'This action could not currently be loaded right now. Please try again later.',
              type: 'error',
            });
            this.$emit('close', true);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      immediate: true,
    },
    show: {
      handler(newValue) {
        this.visible = newValue;
      },
      immediate: true,
    },
  },
  methods: {
    async fetch(id) {
      try {
        const response = await ClientAction.find(id);
        this.clientAction = response.data.data;
      } catch(e) {

      }
    },
    hideModal() {
      this.$emit('update:show', false);
    },
  },
};
</script>

<style lang="scss">
    $modal-header-height: 61px;
    $modal-footer-height: 91px;
    $modal-body-padding: 35px;
    $tab-nav-height: 65px;
    $tab-nav-small-height: 65px;
    $tab-content-padding: 30px;
    $tab-sm-adjust: 60px;

    .action-modal {
        .action-buttons {
            .cancel {
                order: -1;
            }
        }

        .action-item {
            > .tabs {
                .tab-content {
                    padding: 15px 0;
                    .tab-pane {
                        overflow-y: auto;
                        padding: 15px 30px;
                        height: calc(var(--window-height, 100vh) - (#{$modal-header-height} +
                            #{$modal-footer-height} +
                            #{$tab-nav-height})
                            + #{$tab-sm-adjust}
                        );
                    }
                }
            }
        }

        .modal-body {
            padding: 0;
        }
    }

    @include media-breakpoint-up(md) {
        .action-modal {
            .modal-body {
                padding: map_get($spacers, 3);
            }

            .action-item {
                > .tabs {
                    .tab-content {
                        .tab-pane {
                            height: calc(var(--window-height, 100vh) - (#{$modal-header-height} +
                            #{$modal-footer-height} +
                            #{$modal-body-padding} +
                            #{$tab-nav-height} +
                            #{$tab-content-padding})
                            );
                        }
                    }
                }
            }
        }
    }
</style>
